import React from "react";
import { Header } from "semantic-ui-react";

export default function NotFound(){
    return (<Header>NotFound</Header>);
}